import { useInvalidatePortfolios } from '@/entities/portfolio';
import { trpc } from '@/shared/api';
import { useAsyncAction } from '@/shared/lib';

export const useRenamePortfolioCategory = () => {
  const mutation = trpc.portfolioManagement.categories.rename.useMutation();
  const action = useAsyncAction(mutation.mutateAsync, useInvalidatePortfolios());
  return { ...action, renameCategory: action.execute };
};
